<template>
    <ModalDialog
        id="delete-modal"
        ref="modal"
        size="sm"
        :isLoading="isLoading"
        @submit="deleteAccount"
        @closed="$emit('closed')"
    >
        <template #header>
            <div v-if="isValid">
                {{ $t('delete') }} <b>{{ account.name }}?</b>
            </div>
            <div v-else>
                {{ $t('deleting') }} <b>{{ account.name }}</b>
            </div>
        </template>

        <template #default>
            <Alerts style="margin: 20px 15px" />
        </template>

        <template
            v-if="!isValid"
            #body
        >
            {{ $t('messages.api.account.noDeleting', { name: account.name }) }}
        </template>

        <template #footer="{ close, submit }">
            <button
                class="btn btn-sm btn-default"
                type="button"
                data-dismiss="modal"
                :disabled="isLoading"
                @click="close"
            >
                {{ isValid ? $t('cancel') : $t('close') }}
            </button>

            <button
                v-if="isValid"
                class="btn btn-sm btn-danger"
                :disabled="isLoading"
                @click="submit"
            >
                <i
                    v-if="isLoading"
                    class="fa fa-refresh fa-spin"
                />
                <span>{{ $t('delete') }}</span>
            </button>
        </template>
    </ModalDialog>
</template>

<script>
import EventBus from '@/event-bus';
import ModalDialog from '@/components/modals/ModalDialog.vue';

export default {
    components: {
        ModalDialog,
    },
    props: {
        account: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
        };
    },
    computed: {
        isValid() {
            return !!(!this.account.apis || this.account.apis.length <= 0);
        },
    },
    watch: {
        account() {
            EventBus.$emit('alertOptions', {
                displayAlert: false,
            });
        },
    },
    methods: {
        async deleteAccount() {
            if (!this.isValid) return;

            try {
                this.isLoading = true;
                this.$emit('loading', this.isLoading);

                const {
                    data: { name },
                } = await axios.delete(`/apis/accounts/data/account`, {
                    params: {
                        id: this.account.id,
                    },
                });

                this.$refs.modal.close();

                await this.$emit('deleted', name);

                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: this.$t('messages.api.account.deleted', { name }),
                });
            } catch (error) {
                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.isLoading = false;
                this.$emit('loading', this.isLoading);
            }
        },
    },
};
</script>
